import { render } from "./App.vue?vue&type=template&id=fe4e0f4e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fe4e0f4e&lang=less"

import exportComponent from "F:\\frontEndWorkspace\\yjd-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__